import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from '../lib/formatter.ts';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import useDetail from 'hooks/useDetail';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import CommonFns from 'functions/common.ts';
import PricingService from 'services/pricing';
import Big from 'big.js';
import { Link } from 'react-router-dom';
import BodydCustField from 'components/bodyCustField';
//单头自定义字段
import HeadCustField from 'components/headCustField';
import Download from 'components/download.js';
import { DETAIL_FIELD_CONFIG } from '../constants/bill-field-config.ts';
import CompanyService from 'services/company2';
import Http from 'services/http2';
import Util from 'lib/util.js';

// const styles = theme => ({
//   card: {
//     margin: '10px 5px',
//   },
// });

function PricingProcessDetail(props) {
  const Config = {
    purchase: {
      title: '核价单详情',
      apiPath: '/price/order/detail',
      companyCodeKey: 'companyCode',
      companyNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_Price_Order_Status',
          subKey: 'status',
          value: 'statusName'
        },
        {
          mainKey: 'B02_Order_Sync_Status',
          subKey: 'syncStatus',
          value: 'syncStatusName'
        }
      ],
      idField: 'prcXkNo',
      custFieldBillType: 23, //自定义字段单别
      wfmCode: '1064'
    }
  };

  const { state, dispatch } = useContext(ActionContext);
  const [detailField, setDetailField] = useState([]);
  const [companyParams, setCompanyParams] = useState({});
  const config = Config[props.type];
  config.dispatch = dispatch;
  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    moreSign1,
    moreSign2,
    handleMore,
    decimalPlace,
    fileList,
    setShowLoading,
    setFileList,
    setRedirect,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    fieldSetting,
    self
  } = useDetail(props, config);

  //处理详情数据
  self.afterGetDetail = function (data) {
    if (self.isPurchase) {
      getCompanyParams(data.companyCode);
      //适用公司
      if (Array.isArray(data.usedCompList)) {
        data.usedCompanyName = data.usedCompList
          .map(val => val.usedCompanyName)
          .join();
      }
      if (Array.isArray(data.lineList)) {
        data.lineList.forEach(item => {
          let price = (item.isContainTax ? item.taxPrice : item.price) || 0;
          item.taxRateShow = item.taxRate ? item.taxRate * 100 + '%' : '';
          if (item.taxPrice && item.lastPrice && item.lastPrice !== 0) {
            // 降价率 = （本次单价 - 最近单价）/ 最近单价 * 100% - 不考虑降价率标题名称问题，负百分比为降价，正百分比为涨价（按正负，匹配涨价降价的箭头符号）
            // 打印依赖此值
            item.priceCutRate = Big(price)
              .minus(item.lastPrice)
              .div(item.lastPrice)
              .times(100)
              .toFixed(2);
            if (Big(item.priceCutRate).lt(0)) {
              item.isRise = false;
            } else if (Big(item.priceCutRate).gt(0)) {
              item.isRise = true;
            }
          }
          // if (item.taxPrice && item.lastPrice && item.lastPrice !== 0) {
          //   item.priceCutRate = Big(item.taxPrice)
          //     .minus(item.lastPrice)
          //     .div(item.lastPrice)
          //     .times(100)
          //     .toFixed(2);
          //   if (item.taxPrice > item.lastPrice) {
          //     item.isRise = true;
          //   } else if (item.taxPrice < item.lastPrice) {
          //     item.isRise = false;
          //   }
          // }
        });
      }
    }
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);

    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();

    function userPreferenceDetail() {
      let postbody = {
        objCode: companyCode,
        objType: 2,
        contentType: '23',
        apiPath: '/userSetting/userPreferenceDetail'
      };
      Http.post('/api/cloudCenter', postbody).then(response => {
        if (response.success && response.data) {
          let res = Util.jsonDecode(response.data.contentJson) || {};
          if (res) {
            res.mobileDetailField = !Util.isEmpty(res.mobileDetailField)
              ? res.mobileDetailField
              : DETAIL_FIELD_CONFIG['23_mobile'];
            // 单据详情字段
            if (!Util.isEmpty(res.mobileDetailField)) {
              for (
                let i = 0;
                i < DETAIL_FIELD_CONFIG['23_mobile'].length;
                i++
              ) {
                let field = DETAIL_FIELD_CONFIG['23_mobile'][i];
                if (
                  res.mobileDetailField.some(
                    item => item.component === field.component
                  )
                ) {
                  field.hide =
                    res.mobileDetailField.filter(
                      item => item.component === field.component
                    )[0].hide || false;
                }
              }
              let mobileDetailField = DETAIL_FIELD_CONFIG['23_mobile']
                .filter(item => !item.hide)
                .map(item => item.component);
              setDetailField(mobileDetailField);
            }
          }
        }
      });
    }

    userPreferenceDetail();
  }, [companyCode, self]);

  /** 采购方操作 begin **/

  // 获取企业平台参数
  function getCompanyParams(customerCode) {
    CompanyService.getCompanyParamsByCodes(customerCode, [
      'Supplier_Quotation_Attachment_Cited_Price_Evaluation'
    ]).then(res => {
      if (Array.isArray(res)) {
        res.forEach(item => {
          companyParams[item.paramCode] = item.paramValue;
        });
        setCompanyParams(companyParams);
      }
    });
  }

  //发布
  function publish() {
    let postbody = {
      companyCode: companyCode,
      prcXkNo: self.id
    };
    PricingService.publish(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //作废
  function abandon() {
    let postbody = {
      companyCode: companyCode,
      prcXkNo: self.id
    };
    PricingService.abandon(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //撤回
  function recall() {
    let postbody = {
      companyCode: companyCode,
      prcXkNo: self.id
    };
    PricingService.recall(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //审核
  function audit() {
    let postbody = {
      companyCode: companyCode,
      prcXkNo: self.id
    };
    PricingService.audit(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //下行ERP
  function handleERP() {
    let postbody = {
      companyCode: companyCode,
      prcXkNo: self.id
    };
    PricingService.handleERP(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  function showFileList(businessType, obj) {
    const { actions } = props;
    let businessKey = detail.prcXkNo,
      cCode = obj[config.companyCodeKey],
      xkNo = obj.prcXkNo,
      lineNo = obj.lineNo;

    if (businessType === 161) {
      businessKey = xkNo + '_' + lineNo;
    }

    setShowLoading(true);
    CompanyService.getFileList(
      businessType,
      businessKey,
      xkNo,
      lineNo,
      cCode
    ).then(res => {
      setShowLoading(false);
      if (Array.isArray(res)) {
        let arr = res.map(row => {
          return { ...row };
        });
        setFileList(arr);
      }
    });
    actions.openDownloadModal();
  }

  /** 采购方操作 end **/

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="m-details-container">
        <div className="m-details-item">
          <div className="details-item-title">
            <label>基础信息</label>
          </div>
          <div className="details-item-content">
            <div className="content-line">
              <ul className="field-list">
                {detail.prcErpNo && (
                  <li>
                    <span className="field-label">ERP单号</span>
                    <div className="field-value">{detail.prcErpNo}</div>
                  </li>
                )}
                <li>
                  <span className="field-label">供应商</span>
                  <div className="field-value">
                    {detail.innerVendorName}({detail.innerVendorCode})
                  </div>
                </li>
                <li>
                  <span className="field-label">采购组织</span>
                  <div className="field-value">{detail.erpOrgName}</div>
                </li>
                <li>
                  <span className="field-label">工厂</span>
                  <div className="field-value">{detail.profitCenterName}</div>
                </li>
                {detail.sourceXkNo && (
                  <li>
                    {/* 来源单据类型：1：单物料竞价，2：多物料竞价，3：比价单，4：报价单（已作废）")  */}
                    <span className="field-label">来源单号</span>
                    <div className="field-value">
                      {!detail.sourceCompanyName ? (
                        <Link
                          to={
                            detail.sourceType === 1
                              ? `/mp/purchase/inquiry/bid-multi/detail/${companyCode}/${detail.sourceXkNo}`
                              : detail.sourceType === 2
                                ? `/mp/purchase/inquiry/bid/detail/${companyCode}/${detail.sourceXkNo}`
                                : detail.sourceType === 3
                                  ? `/mp/purchase/inquiry/quote-compare/detail/${companyCode}/${detail.sourceXkNo}`
                                  : ''
                          }
                        >
                          {detail.sourceXkNo}
                        </Link>
                      ) : (
                        detail.sourceXkNo(detail.sourceCompanyName)
                      )}
                    </div>
                  </li>
                )}
                <li>
                  <span className="field-label">币别</span>
                  <div className="field-value">{detail.currencyName}</div>
                </li>
                <li>
                  <span className="field-label">付款条件</span>
                  <div className="field-value">{detail.payWayName}</div>
                </li>
                <li>
                  <span className="field-label">核价日期</span>
                  <div className="field-value">
                    {formatDate(detail.pricingTime, 'YYYY-MM-DD')}
                  </div>
                </li>
                <li>
                  <span className="field-label">核价类型</span>
                  <div className="field-value">{detail.pricingTypeName}</div>
                </li>
                <li>
                  <span className="field-label">备注</span>
                  <div className="field-value">{detail.remark}</div>
                </li>
                <li>
                  <span className="field-label">适用公司</span>
                  <div className="field-value">{detail.usedCompanyName}</div>
                </li>
                <li>
                  <span className="field-label">核价单别</span>
                  <div className="field-value">{detail.formTypeName}</div>
                </li>
                <li>
                  <span className="field-label">核价人</span>
                  <div className="field-value">{detail.createName}</div>
                </li>
                <li>
                  <span className="field-label">核价附件</span>
                  <div className="field-value">
                    <span
                      className="attachment"
                      onClick={() => showFileList(66, detail)}
                    >
                      {detail.fileMD5s?.length}个附件
                    </span>
                  </div>
                </li>
                {companyParams[
                  'Supplier_Quotation_Attachment_Cited_Price_Evaluation'
                ]?.indexOf('1') > -1 && (
                  <li>
                    <span className="field-label">报价附件</span>
                    <div className="field-value">
                      {!Util.isEmpty(detail.quoteFileMD5s) && (
                        <span
                          className="attachment"
                          onClick={() => showFileList(160, detail)}
                        >
                          {detail.quoteFileMD5s?.length}个附件
                        </span>
                      )}
                    </div>
                  </li>
                )}
                {detail.syncStatus !== null && (
                  <li>
                    <span className="field-label">同步状态</span>
                    <div className="field-value">
                      <span
                        className={
                          'u-sign ' +
                          CommonFns.getStatusClass('sync', detail.syncStatus)
                        }
                      >
                        {detail.syncStatusName}
                      </span>
                    </div>
                  </li>
                )}
                {detail.syncDate && (
                  <li>
                    <span className="field-label">同步时间</span>
                    <div className="field-value">
                      {formatDate(detail.syncDate, 'YYYY-MM-DD HH:mm')}
                    </div>
                  </li>
                )}
                {detail.syncMessage && (
                  <li>
                    <span className="field-label">同步消息</span>
                    <div className="field-value">{detail.syncMessage}</div>
                  </li>
                )}
                <li>
                  <span className="field-label">状态</span>
                  <div className="field-value">
                    <span
                      className={
                        'u-sign ' +
                        CommonFns.getStatusClass('pricing', detail.status)
                      }
                    >
                      {detail.statusName}
                    </span>
                  </div>
                </li>
                {/* 审批流状态 仅开启后才显示 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批环节</span>
                    <div className="field-value">
                      <WorkflowStatus
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                      />
                    </div>
                  </li>
                )}
                {/* 审批流按钮 */}
                {self.isPurchase && updateTs > 0 && workflow.isActive && (
                  <li>
                    <span className="field-label">审批操作</span>
                    <div className="field-value">
                      <WorkflowButtons
                        companyCode={companyCode}
                        id={self.id}
                        workflow={workflow}
                        detail={detail}
                        onChange={() => {
                          self.getDetail();
                        }}
                      />
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </div>
          {/* <div
            className={moreSign1 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(1);
            }}
          >
            {moreSign1 && '更多'}
            {!moreSign1 && '收起'}
            <i className="icon-down"></i>
          </div> */}
        </div>

        <div className="m-details-item">
          {/* 单头自定义 */}
          <HeadCustField
            fieldSetting={fieldSetting}
            detail={detail}
            setDetail={setDetail}
            isPurchase={self.isPurchase}
          ></HeadCustField>
        </div>

        <div className="m-details-item">
          <div className="details-item-title">
            <label>核价明细</label>
          </div>
          <div className="details-item-content">
            {detail.lineList &&
              detail.lineList.map((item, index) => (
                <div
                  className="content-line line-list-item"
                  key={String(item.id) + index}
                >
                  <div className="line-list-item-title">
                    <span>项次 {item.lineNo}</span>
                  </div>

                  <ul className="field-list">
                    <li>
                      <span className="field-label">物料编码</span>
                      <div className="field-value">{item.productCode}</div>
                    </li>
                    {detailField.includes('productName') && (
                      <li>
                        <span className="field-label">物料名称</span>
                        <div className="field-value">{item.productName}</div>
                      </li>
                    )}
                    {detailField.includes('productScale') && (
                      <li>
                        <span className="field-label">物料规格</span>
                        <div className="field-value">{item.productScale}</div>
                      </li>
                    )}
                    {
                      <li>
                        <span className="field-label">工序编码</span>
                        <div className="field-value">{item.processCode}</div>
                      </li>
                    }
                    {
                      <li>
                        <span className="field-label">工序名称</span>
                        <div className="field-value">{item.processName}</div>
                      </li>
                    }
                    {detailField.includes('startQty') && (
                      <li>
                        <span className="field-label">起始数量</span>
                        <div className="field-value">
                          {formatNumber(
                            item.startQty,
                            decimalPlace.Quantity_Decimal_Place
                          )}
                        </div>
                      </li>
                    )}
                    {detailField.includes('endQty') && (
                      <li>
                        <span className="field-label">截止数量</span>
                        <div className="field-value">
                          {formatNumber(
                            item.endQty,
                            decimalPlace.Quantity_Decimal_Place
                          )}
                        </div>
                      </li>
                    )}
                    {detailField.includes('endQty') && (
                      <li>
                        <span className="field-label">最小采购量</span>
                        <div className="field-value">
                          {formatNumber(
                            item.minPurchaseQty,
                            decimalPlace.Quantity_Decimal_Place
                          )}
                        </div>
                      </li>
                    )}
                    {detailField.includes('unitName') && (
                      <li>
                        <span className="field-label">采购单位</span>
                        <div className="field-value">{item.unitName}</div>
                      </li>
                    )}
                    {detailField.includes('taxPrice') && (
                      <li>
                        <span className="field-label">含税单价</span>
                        <div className="field-value">
                          {item.taxPrice &&
                            formatNumber(
                              item.taxPrice,
                              decimalPlace.Price_Decimal_Place
                            )}
                        </div>
                      </li>
                    )}
                    {detailField.includes('price') && (
                      <li>
                        <span className="field-label">未税单价</span>
                        <div className="field-value">
                          {item.price &&
                            formatNumber(
                              item.price,
                              decimalPlace.Price_Decimal_Place
                            )}
                        </div>
                      </li>
                    )}
                    {detailField.includes('taxName') && (
                      <li>
                        <span className="field-label">税别</span>
                        <div className="field-value">{item.taxName}</div>
                      </li>
                    )}
                    {detailField.includes('taxRateShow') && (
                      <li>
                        <span className="field-label">税率</span>
                        <div className="field-value">{item.taxRateShow}</div>
                      </li>
                    )}
                    {detailField.includes('purchaseRate') && (
                      <li>
                        <span className="field-label">采购比例</span>
                        <div className="field-value">
                          {item.purchaseRate ? item.purchaseRate + '%' : ''}
                        </div>
                      </li>
                    )}
                    {detailField.includes('lastPrice') && (
                      <li>
                        <span className="field-label">最近核价单价</span>
                        <div className="field-value">
                          {item.lastPrice &&
                            formatNumber(
                              item.lastPrice,
                              decimalPlace.Price_Decimal_Place
                            )}
                        </div>
                      </li>
                    )}

                    {detailField.includes('minLastPrice') && (
                      <li>
                        <span className="field-label">最低核价单价</span>
                        <div className="field-value">
                          {item.minLastPrice &&
                            formatNumber(
                              item.minLastPrice,
                              decimalPlace.Price_Decimal_Place
                            )}
                        </div>
                      </li>
                    )}
                    {detailField.includes('priceCutRate') && (
                      <li>
                        <span className="field-label">降价率</span>
                        <div className="field-value">
                          {item.taxPrice && item.lastPrice && (
                            <span className={item.isRise ? 'red' : 'green'}>
                              {item.isRise && '+'}
                              {item.priceCutRate ? item.priceCutRate + '%' : ''}
                              {item.isRise && <i className="icon-go-up"></i>}
                              {!item.isRise && <i className="icon-go-down"></i>}
                            </span>
                          )}
                        </div>
                      </li>
                    )}

                    {detailField.includes('quotePrice') && (
                      <li>
                        <span className="field-label">报价单价</span>
                        <div className="field-value">
                          {item.quotePrice &&
                            formatNumber(
                              item.quotePrice,
                              decimalPlace.Price_Decimal_Place
                            )}
                        </div>
                      </li>
                    )}

                    {detailField.includes('minQuotePrice') && (
                      <li>
                        <span className="field-label">最低报价单价</span>
                        <div className="field-value">
                          {item.quotePrice &&
                            formatNumber(
                              item.minQuotePrice,
                              decimalPlace.Price_Decimal_Place
                            )}
                        </div>
                      </li>
                    )}

                    {detailField.includes('effectiveDate') && (
                      <li>
                        <span className="field-label">生效日期</span>
                        <div className="field-value">
                          {formatDate(item.effectiveDate, 'YYYY-MM-DD')}
                        </div>
                      </li>
                    )}

                    {detailField.includes('invalidDate') && (
                      <li>
                        <span className="field-label">失效日期</span>
                        <div className="field-value">
                          {formatDate(item.invalidDate, 'YYYY-MM-DD')}
                        </div>
                      </li>
                    )}

                    {detailField.includes('transportTypeName') && (
                      <li>
                        <span className="field-label">运输方式</span>
                        <div className="field-value">
                          {item.transportTypeName}
                        </div>
                      </li>
                    )}

                    {detailField.includes('brandName') && (
                      <li>
                        <span className="field-label">品牌</span>
                        <div className="field-value">{item.brandName}</div>
                      </li>
                    )}

                    {detailField.includes('promiseDeliDays') && (
                      <li>
                        <span className="field-label">承诺交期</span>
                        <div className="field-value">
                          {item.promiseDeliDays
                            ? item.promiseDeliDays + '天'
                            : ''}
                        </div>
                      </li>
                    )}

                    {detailField.includes('minPackage') && (
                      <li>
                        <span className="field-label">最小包装</span>
                        <div className="field-value">{item.minPackage}</div>
                      </li>
                    )}

                    {detailField.includes('manufacturerProdCode') && (
                      <li>
                        <span className="field-label">制造商料号</span>
                        <div className="field-value">
                          {item.manufacturerProdCode}
                        </div>
                      </li>
                    )}

                    {detailField.includes('modelFee') && (
                      <li>
                        <span className="field-label">模具费用</span>
                        <div className="field-value">{item.modelFee}</div>
                      </li>
                    )}

                    {detailField.includes('remark') && (
                      <li>
                        <span className="field-label">备注</span>
                        <div className="field-value">{item.remark}</div>
                      </li>
                    )}

                    {companyParams[
                      'Supplier_Quotation_Attachment_Cited_Price_Evaluation'
                    ]?.indexOf('2') > -1 && (
                      <li>
                        <span className="field-label">报价附件</span>
                        <div className="field-value">
                          {!Util.isEmpty(item.quoteFileMD5s) && (
                            <span
                              className="attachment"
                              onClick={() => showFileList(161, item, index)}
                            >
                              {item.quoteFileMD5s.length}个附件
                            </span>
                          )}
                        </div>
                      </li>
                    )}

                    {detailField.includes('priceCompareDesc') &&
                      detail.sourceType === 3 && (
                        <li>
                          <span className="field-label">比价说明</span>
                          <div className="field-value">
                            {item.priceCompareDesc}
                          </div>
                        </li>
                      )}
                  </ul>
                  {/* 单身自定义字段 */}
                  {detailField.includes('prodfieldSet') && (
                    <BodydCustField
                      fieldSetting={fieldSetting}
                      line={item}
                      isPurchase={self.isPurchase}
                    ></BodydCustField>
                  )}
                  {/* <BodydCustField
                    fieldSetting={fieldSetting}
                    line={item}
                    isPurchase={self.isPurchase}
                  ></BodydCustField> */}
                </div>
              ))}
          </div>
        </div>
      </div>

      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10071703') && [0, 4].includes(detail.status) && (
            <Button
              type="default"
              onClick={() => {
                publish();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              发布
            </Button>
          )}
          {User.checkAuth('10071705') &&
            [2].includes(detail.status) &&
            detail.syncStatus !== 1 && (
              <Button
                type="default"
                onClick={() => {
                  abandon();
                }}
                className="m-flex-item u-btn u-btn_warn"
              >
                作废
              </Button>
            )}
          {User.checkAuth('10071703') &&
            (detail.status === 1 ||
              (detail.status === 2 && detail.syncStatus === 3)) &&
            workflow.data &&
            workflow.data['process_pricing_audit'].complete && (
              <Button
                type="default"
                onClick={() => {
                  recall();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                撤回
              </Button>
            )}
          {User.checkAuth('10071704') &&
            detail.status === 1 &&
            workflow.data &&
            workflow.data['process_pricing_audit'].complete && (
              <Button
                type="default"
                onClick={() => {
                  audit();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                审核
              </Button>
            )}
          {User.checkAuth('10071702') &&
            detail.status === 2 &&
            [1].includes(detail.sourceSystem) &&
            [null, 0, 3].includes(detail.syncStatus) && (
              <Button
                type="default"
                onClick={() => {
                  handleERP();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                下行ERP
              </Button>
            )}
        </div>
      )}
      <Modal></Modal>
      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
    </div>
  );
}

PricingProcessDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PricingProcessDetail);
